export default "__VITE_ASSET__CqfF7vHs__"